import { render } from "./NewCategory.vue?vue&type=template&id=f491b1d0&scoped=true"
import script from "./NewCategory.vue?vue&type=script&lang=js"
export * from "./NewCategory.vue?vue&type=script&lang=js"

import "./NewCategory.vue?vue&type=style&index=0&id=f491b1d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f491b1d0"]])

export default __exports__